var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFinetuneParametersVocabulary = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m9.447 3.333 3.22 3.22v6.114H3.333V3.333zm0-1.333H3.333C2.6 2 2 2.6 2 3.333v9.334C2 13.4 2.6 14 3.333 14h9.334C13.4 14 14 13.4 14 12.667V6.553c0-.353-.14-.693-.393-.94l-3.22-3.22A1.3 1.3 0 0 0 9.447 2m-4.78 8h6.666v1.333H4.667zm0-2.667h6.666v1.334H4.667zm0-2.666h4.666V6H4.667z"
})));
export default SvgFinetuneParametersVocabulary;